import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { NgbPopoverModule, NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
import { UiModule } from "../ui.module";
import { PlannerItemComponent } from "./planner-item/planner-item.component";
import { PlannerBoardComponent } from "./planner-board/planner-board.component";
import { PlannerDayBoardComponent } from "./planner-day-board/planner-day-board.component";
import { PlannerWeekPagerComponent } from "./planner-week-pager/planner-week-pager.component";

/**
 * The weekly planner board, shared by the student app and the coach panel.
 *
 * Everything here is presentational: no HTTP, no store, no modals. The hosting app decides which
 * endpoints an action hits and which dialogs it opens, which is what lets the same board serve a
 * student editing their own plan and a coach editing a student's.
 */
@NgModule({
  declarations: [PlannerItemComponent, PlannerBoardComponent, PlannerDayBoardComponent, PlannerWeekPagerComponent],
  imports: [CommonModule, DragDropModule, NgbPopoverModule, NgbTooltipModule, TranslateModule, UiModule],
  exports: [PlannerItemComponent, PlannerBoardComponent, PlannerDayBoardComponent, PlannerWeekPagerComponent],
})
export class PlannerModule {
}
